import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DealerSetup } from '../models/dealer-setup.model';
import { SiteSetup, SiteSetupResponse } from '../models/response.model';
import { PlantTransfer } from '../models/plant-transfer.model';
import { map } from 'rxjs/operators';

export interface DealerSetupResponse {
  data: DealerSetup;
  error: any[];
}

@Injectable({
  providedIn: 'root'
})
export class DealerDataService {
  private http = inject(HttpClient);

  getDealerSetup(): Observable<DealerSetupResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getDealerSetup}`;
    return this.http.get<DealerSetupResponse>(url);
  }
  updateSite(payload: SiteSetup): Observable<SiteSetupResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.updateSite}`;
    return this.http.post<SiteSetupResponse>(url, payload);
  }

  updateDealerSetup(payload: { [p: string]: DealerSetup }): Observable<DealerSetupResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.updateDealerSetup}`;
    return this.http.post<DealerSetupResponse>(url, payload);
  }

  updatePosSetup(payload: DealerSetup): Observable<DealerSetupResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.updatePosSetup}`;
    return this.http.post<DealerSetupResponse>(url, payload);
  }

  getAllPlantTransfer(filters: any): Observable<PlantTransfer[]> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getAllPlantTransfer}`;
    const filteredParams = Object.entries(filters || {}).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);
    return this.http
      .get<{ data: { plantTransfers: PlantTransfer[] } }>(url, { params: filteredParams })
      .pipe(map((response) => response.data.plantTransfers));
  }

  getNewDealerPlantTransferPk(): Observable<string> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getNewDealerPlantTransferPk}`;
    return this.http.get<string>(url);
  }

  deleteDealerPlantTransfer(plantTransferPk: string): Observable<void> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.deletePlantTransfer}/${plantTransferPk}`;
    return this.http.delete<any>(url);
  }

  updatePlantTransfer(payload: PlantTransfer[]): Observable<PlantTransfer[]> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.updatePlantTransfer}`;
    return this.http.post<PlantTransfer[]>(url, payload);
  }

  getDealerDateFormat(dealerId: string): Observable<string> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getDealerDateFormat.replace('{dealerId}', dealerId)}`;
    return this.http.get<string>(url);
  }

  getPosEnabled(dealerId: string): Observable<string> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getPosEnabled.replace('{dealerId}', dealerId)}`;
    return this.http.get<string>(url);
  }
}
